import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";

import "../excalidraw-app/sentry";

import { applyBranding } from "./branding/applyBranding";
import { CookieConsentBanner } from "./components/CookieConsentBanner";
import ExcalidrawApp from "./App";

applyBranding();

window.__EXCALIDRAW_SHA__ = import.meta.env.VITE_APP_GIT_SHA;
const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);
registerSW();
root.render(
  <StrictMode>
    <ExcalidrawApp />
    <CookieConsentBanner />
  </StrictMode>,
);
